import React, { useState, useEffect } from "react";

import { Row } from "react-bootstrap";

import { useMultiFilterContext } from "contexts/MultiFilterContext";
import FilterItem from "./FilterItem";

export default function FilterGroupVisiblePart({ filterWrapper, filterGroup }) {
  const { dispatch, actions, state } = useMultiFilterContext();

  return (
    <Row>
      {filterGroup.items
        .filter((n) => n.show)
        .map((value, index) => {
          return (
            <FilterItem
              key={index}
              item={value}
              size={filterWrapper.className == "column2" ? 6 : 4}
            />
          );
        })}
    </Row>
  );
}
